import type { CurrentWhitelabelConfigResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export const WHITELABEL_CURRENT_QUERY_KEY = ["whitelabel", "current"];

export function useWhitelabelConfig() {
  return useQuery<CurrentWhitelabelConfigResponse>({
    queryFn: () => apiClient.url("/whitelabel/config/current").get().json(),
    queryKey: WHITELABEL_CURRENT_QUERY_KEY,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
